export const ViewerType = 'wixui.TextMask' as const;
export const DataType = 'TextFxData' as const;
export const DesignType = 'TextFxMask' as const;
export const PropertiesType = 'DefaultProperties' as const;

export const mediaCategory = 'BG_MEDIA';

export const helpIds = {
  gfpp: '6dcc5f19-78a8-415c-8f1c-75117779e0cc',
  learnMore: '97987d95-8c66-452a-bde9-d4ac7515c193',
  settingsPanelInfo: '0a4d90dc-a980-42db-ac8c-629963507563',
  designPanelInfo: '40f36de5-0beb-4238-911c-0e8f4a97d6d4',
  responsive: 'help.gfpp-TextMask',
};

export const TranslationKeys = {
  ariaLabel: 'TextMask_AriaLabel_PlayMask',
  pauseLabel: 'TextEffects_MediaButton_Pause',
  playLabel: 'TextEffects_MediaButton_Play',
  namespace: 'ariaLabels',
};

export const TestIds = {
  headingTag: 'heading-tag',
};

export const INITIAL_VIEW_BOX = '0 0 0 0';
